import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

import { GlobalStorage } from 'src/app/apv/core/services/globals.service';
import { APV_ROUTES } from '../constants';
import { Auth } from '@angular/fire/auth';

@Injectable({ providedIn: 'root' })
export class TokenGuard  {
  constructor(public globalSvc: GlobalStorage, private readonly router: Router, private readonly firebaseAuth: Auth) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    if (route.queryParams['amount'] && route.queryParams['currency'] && !this.globalSvc.token) {
      try {
      sessionStorage.removeItem('subscription');
      const firebasetoken = String(await (
        await this.firebaseAuth.currentUser
      )?.getIdToken());
      this.globalSvc.token = firebasetoken;
      } catch (error) {
        console.error('Error storing token',error);
      }
    } 
    if (this.globalSvc.token) {
      return true;
    } else {
      this.router.navigate([APV_ROUTES.HOME]);
      return false;
    }
  }
}
